<template>
    <div style="height: 100%;">
        <Header />
        <router-view></router-view>
        <Footer :isLogin="true"/>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
    name: 'Detail',
    components: {
        Header,
        Footer
    },
   /*  watch: {
        $route(to,from) {
            this.title = to.meta.title;
            this.isMobile = to.path.includes('/m-mine');
        }
    }, */
    data() {
        return {
            title: '',
        }
    },
    mounted() {
        this.title = this.$route.meta.title;
    },
}
</script>

<style scoped>
</style>